import { Controller } from "@hotwired/stimulus"
import FingerprintJS from "@fingerprintjs/fingerprintjs"

export default class extends Controller {
  connect() {
    FingerprintJS.load()
      .then(fp => fp.get())
      .then(result => {
        const body = new FormData()
        body.append("fingerprint", result.visitorId)
        body.append("authenticity_token", document.querySelector('meta[name="csrf-token"]').content)
        fetch(this.element.dataset.url, { method: "POST", body })
      })
  }
}
